import { find, filter, map, sum, clone, cloneDeep } from 'lodash';

class OrderSummaryController {

    constructor($rootScope, $state, $stateParams, ordersApiService, messageService, access, propertyService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
        this.access = access;
        this.propertyService = propertyService;
    }

    $onInit () {
        this.orderStatusId = clone(this.order.order_status_id);

        if (this.order.item.length && this.order.basket.guest_details.length) {
            for (let key in this.order.basket.guest_details) {
                this.order.basket.guest_details[key].total = sum(map(filter(this.order.item, { 'guest_id': this.order.basket.guest_details[key].id }), item => {
                    return parseFloat(item.price);
                }));
            }
        }

        if (this.order.vouchers.length) this.sumVouchers();

        this.setState();
    }

    setState () {
        this.paymentId = this.paymentID();
        this.paymentGateway = this.propertyService.get('finance').payment_gateway;
    }

    boolean (bool) {
        if (bool === 1 || bool === true) {
            return 'Yes';
        }

        return 'No';
    }

    guestItems (id) {
        return filter(this.order.item, { 'guest_id': id, 'item_parent': null });
    }

    findPaidTransaction () {
        return find(this.order.transaction, { 'code': '200', 'payment_status_id': 4 });
    }

    paymentDate () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.created_at;
        }
        return '';
    }

    paymentID () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.transaction_id;
        }
        return '';
    }

    paymentType () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.card_type;
        }
        return 'Unknown';
    }

    paymentDigits () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return `**** **** **** ${log.details.card_last_4}`;
        }
        return '';
    }

    paymentExpiry () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.card_expiry;
        }
        return '';
    }

    paymentReceived () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.amount;
        }
        return '';
    }

    paysafeOrderRef () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.merchant_reference;
        }
        return '';
    }

    destinationPayment () {
        let log = this.findPaidTransaction();
        if (log && log.details) {
            return log.details.destination_payment;
        }
        return '';
    }

    guestPrice (guest) {
        let total = 0;

        let guestItems = this.guestItems(guest);

        if (guest && guestItems) {
            for (let item of guestItems) {
                if (item.price) {
                    total += this.totalItem(item);
                }
            }
        }

        return total;
    }

    onSave () {
        let ordercopy = cloneDeep(this.order);

        delete (this.order.basket);
        delete (this.order.item);
        delete (this.order.customer);

        return this.ordersApiService.save(this.order)
            .then(response => {
                if (this.order.deleted_at !== null) {
                    this.messageService.success(`The order <strong>${this.order.order_reference}</strong> was successfully revived!`, [`app.admin.order-edit({ 'order' : ${this.order.id}})`, `Order`]);
                    this.$state.go('app.admin.orders');
                } else if (this.order.id) {
                    this.messageService.success(`The order <strong>${this.order.order_reference}</strong> was successfully updated!`);
                    this.messageService.push();
                    this.$state.go('app.admin.order-edit', { order: this.order.id });
                } else {
                    this.messageService.success(`The Order <strong>${this.order.order_reference}</strong> was successfully created. Please edit the start times.`, [`app.admin.order-edit({ 'order' : ${response.id}})`, `Order`]);
                    this.$state.go('app.admin.order-edit', { order: response.id });
                }
                this.order = ordercopy;
            })
            .catch((error) => {
                // this.messageService.failure(`The order <strong>${this.order.name}</strong> could not be successfully created: ${error.statusText}`);
                // this.messageService.push();
            });
    }

    totalItem (item, total = 0) {
        total += parseFloat(item.price);
        if (item.children.length) {
            for (let child of item.children) {
                if (child.price > 0) {
                    total += parseFloat(child.price);
                }
            }
        }
        return total;
    }

    sumVouchers () {
        this.vouchertotal = 0;
        for (let voucher of this.order.vouchers) {
            this.vouchertotal += voucher.codevalue;
        }
    }

    isDisputed () {
        return this.order.order_status === 'Disputed';
    }

    displayGatewayFee () {
        if (this.order.refundable_amount === 0) {
            return 0;
        }

        return this.order.gateway_fee;
    }

    displayApplicationFee () {
        if (this.order.refundable_amount === 0) {
            return 0;
        }

        return this.order.application_fee;
    }

    stripeId () {
        const finance = this.propertyService.get('finance');
        if (finance) {
            return finance.stripe_user_id;
        }
    }
}

OrderSummaryController.$inject = ['$rootScope', '$state', '$stateParams', 'ordersApiService', 'messageService', 'access', 'propertyService'];

export default OrderSummaryController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.summary.controller.js